import React from "react";

const UserTable = ({ users, deleteUser, selectUser }) => {
  if (users.length) {
    return (
      <table className="table table-bordered table-hover table-striped table-condensed">
        <thead>
          <tr>
            <th>User</th>
            <th>Is Admin</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => {
            return (
              <tr key={u.usr_id}>
                <td>
                  <a
                    href="/"
                    onClick={e => {
                      e.preventDefault();
                      selectUser(u.usr_id);
                    }}
                  >
                    {u.usr_username}
                  </a>
                </td>
                <td>
                  {u.usr_isAdmin ? "Y" : "N"}
                  <span className="pull-right">
                    <a
                      href="/"
                      onClick={e => {
                        e.preventDefault();
                        deleteUser(u.usr_id);
                      }}
                    >
                      <i className="fa fa-trash text-danger" />
                    </a>
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  return <div>No users found</div>;
};

export default UserTable;



// WEBPACK FOOTER //
// ./src/pages/Users/UserTable.jsx